<script>
    export let src;
    export let alt;
    console.log($$slots);
</script>

<style>
    .example-button {
        display: inline flex;
        border: 1px black solid;
        border-radius: 0.15rem;
        border-radius: 0.4rem;
        align-items: center;
        justify-content: space-between;
        padding: 0.2rem;
        margin-top: -0.2rem;
        margin-bottom: -0.2rem;
        height: 1.25rem;
        vertical-align: middle;
        background-color: #eee;
        font-size: 0.6rem;
        text-transform: uppercase;
        letter-spacing: 0.05rem;
    }
    .example-button img {
        width: 1rem;
        height: 1rem;
        margin: 0;
    }
    .example-button span {
        margin-left: 0.25rem;
    }
</style>

<div class="example-button">
    <img src={src} alt={alt}>
    {#if $$slots.default}
        <span><slot></slot></span>
    {/if}
</div>